const pagesAuthInvitationEn = {
  acceptInvitationSuccessfulMessage: '🎉 Successfully created account!',
  agree: 'Checking here, You have read and agree to our <termsOfUseLink>Terms of Service</termsOfUseLink> and <privacyPolicyLink>Privacy Policy</privacyPolicyLink>.',
  email: 'Email',
  error: {
    retryButton: 'Try again',
    temporaryFailure: {
      description: 'Please try again. If it keeps failing, check your network connection.',
      title: 'Could not load the invitation'
    },
    unusableInvitation: {
      description: 'Please contact the person who invited you.',
      title: 'This invitation link cannot be used'
    }
  },
  firstOrGivenName: 'First or given name',
  lastOrFamilyName: 'Last or family name',
  middleName: 'Middle name',
  pageSubtitle: 'Already have an account?',
  pageSubtitleLink: 'Sign in',
  pageTitle: 'Create account',
  password: 'Password',
  passwordErrorMessage: 'Password does not meet the requirements.',
  passwordPlaceholder: 'Enter your password',
  ssoRequired: {
    description: 'This organization requires SSO sign-in. Use the button below to sign in with Microsoft.',
    loginError: 'Could not start SSO sign-in. Please try again.',
    signInButton: 'Sign in with Microsoft'
  },
  submitButton: 'Create account'
};
export default pagesAuthInvitationEn;